module.exports = __webpack_public_path__ + "img/inspector_marshall_vol2.18d47934.jpeg";